import { eq, type InitialQueryBuilder } from "@tanstack/db";

import type { Workspace } from "@storyboard/web-client";
import { markWorkspacesDelivered, updateWorkspaceConfig } from "@/data/workspaceConfig";
import { store } from "@/store/store";
import type { Workspace as WorkspaceType } from "@/store/types";

export async function upsertWorkspace(workspaceRecord: Workspace) {
  await bulkUpsertWorkspace([workspaceRecord]);
}

export async function bulkUpsertWorkspace(records: Workspace[]) {
  records.forEach(updateWorkspaceConfig);
  // Marked even for an empty list: the payload has arrived, so the Dispatch gate stops reading "loading".
  markWorkspacesDelivered();
  if (records.length === 0) return;
  const data: WorkspaceType[] = records.map((workspaceRecord) => ({
    id: workspaceRecord.id,
    name: workspaceRecord.name,
    createdAt: workspaceRecord.createdAt ?? new Date().toISOString(),
    updatedAt: workspaceRecord.updatedAt ?? null,
  }));
  // The old ON CONFLICT SET kept the first-seen createdAt.
  store.upsert("workspace", data, (existing, next) => ({
    ...existing,
    name: next.name,
    updatedAt: next.updatedAt,
  }));
}

export const workspacesQuery = (q: InitialQueryBuilder) => q.from({ workspace: store.collection("workspace") });

export const findWorkspaceQuery = (workspaceId: string) => (q: InitialQueryBuilder) =>
  q
    .from({ workspace: store.collection("workspace") })
    .where(({ workspace }) => eq(workspace.id, workspaceId))
    .select(({ workspace }) => ({ id: workspace.id, name: workspace.name }));
